import useGetCustomerProfileCalculator from './useGetCustomerProfileCalculator'

export default useGetCustomerProfileCalculator
